import { call, fork, put, select, takeEvery } from "redux-saga/effects";
import { GET } from "../../helpers/apiHelper";
import * as action from "./actions";

export const getListState = (state) => state.recoveryLogApp.list;

const loadRecoveryLogListAsync = async (query) => GET(`/recovery-log?${query}`);

function* loadRecoveryLogList({ payload }) {
  try {
    const list = yield select(getListState);
    const param = [
      { name: "page", value: payload.selectedPage },
      { name: "limit", value: payload.limit },
    ];

    if (payload.startDate) {
      param.push({ name: "startDate", value: payload.startDate });
    }
    if (payload.endDate) {
      param.push({ name: "endDate", value: payload.endDate });
    }
    if (payload.date) {
      param.push({ name: "date", value: payload.date });
    }
    if (payload.username && payload.username.trim()) {
      param.push({ name: "username", value: encodeURIComponent(payload.username.trim()) });
    }

    const queryString = param.map((t) => `${t.name}=${t.value}`).join("&");
    const response = yield call(loadRecoveryLogListAsync, queryString);
    yield put(action.loadRecoveryLogListSuccess(response));
  } catch (error) {
    yield put(action.loadRecoveryLogListError(error));
  }
}

export function* watchLoadRecoveryLogList() {
  yield takeEvery(action.RECOVERY_LOG_GET_LIST, loadRecoveryLogList);
}

export default function* rootSaga() {
  yield fork(watchLoadRecoveryLogList);
}
